<div class="info-box" [ngClass]="[borderCss, backgroundCss]">
  <div class="info-box__icon-container" [class.extra-padding]="!!textTitle"
       genTooltip
       [tooltipShow]="tooltipShow"
       [tooltipText]="tooltipText"
       [tooltipPosition]="tooltipPosition">
    <div class="info-box__icon" [ngClass]="iconType + '-icon ' + iconCss"></div>
  </div>
  <div class="info-box__text">
    <div class="info-box__text__title" *ngIf="textTitle" [class.title-error]="iconType === 'error'">
      {{textTitle}}
    </div>
    <div [ngClass]="'info-box__text__message ' + textCss">{{message}}</div>
  </div>
</div>
